import { fileSize } from '@vindr/utils/helpers/common.helper';
import { CloseOutlined, FileOutlined } from '@vindr/icons';
import { Progress } from 'antd';
import classNames from 'classnames';
import { memo } from 'react';
import { statusMap } from '../context/UploadAction';
import { UploaderState } from '../context/type';

const FileRow = ({
  file,
  handleDeleteFile,
  uploading,
}: {
  file: UploaderState['fileList'][number];
  handleDeleteFile: (fileProps: UploaderState['fileList'][number]) => void;
  uploading: UploaderState['uploading'];
}) => {
  return (
    <section className="p-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div
            className={classNames(
              'mr-2 flex h-8 w-8 items-center justify-center rounded-full p-2',
              {
                'bg-[#5d6979]': file?.status === 'ready',
              }
            )}
          >
            {file?.status === 'ready' && <FileOutlined className="fill-[#000] dark:fill-[#fff]" />}
            {file?.status !== 'ready' && (
              <Progress
                type="circle"
                percent={file?.progress | 0} //? Same as Math.floor(file?.progress), but faster
                size="default"
                status={statusMap(file?.status)}
                width={32}
                {...(statusMap(file?.status) === 'converting' && { strokeColor: '#135f63' })}
              />
            )}
          </div>
          <div className="my-2 mr-2 gap-1">
            <p
              className="my-0"
              style={{
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
              }}
            >
              {file?.name}
            </p>
            <p className="my-0 mt-1 text-[#5d6979]">{fileSize(file?.size)}</p>
          </div>
        </div>
        <div className="flex items-center">
          {file?.status === 'ready' && !uploading && (
            <div
              className="mr-2 cursor-pointer fill-[#000] dark:fill-[#fff]"
              onClick={() => handleDeleteFile(file)}
            >
              <CloseOutlined />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default memo(FileRow);
